"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const wrappers_1 = require("quasar/wrappers");
const vue_numerals_1 = __importDefault(require("vue-numerals"));
exports.default = wrappers_1.boot(({ app }) => {
    app.config.globalProperties.VueNumerals = vue_numerals_1.default;
});
